import React from 'react';

import Section from '@common/Section';
import Container from '@common/Container';
import Row from '@common/Row';
import Heading from '@common/Heading';
import Img from '@common/Image';
import Link from '@common/Link';

import * as styles from '@styles/modules/course.module.scss';

const LinkList = ({ data }) => {
  const {
    title,
    list
  } = data;
  return (
    <Section spacing='mb-0'>
      <Container className={styles.topBorder}>
        {title && <Heading type='h2' className='fw-semibold mb-4 text-center text-uppercase'>{title}</Heading>}
        <div className='d-flex flex-column align-items-center'>
          {list &&
            <Row className='flex-column flex-md-row align-items-center gx-3 gy-3 mb-4' style={{width:'736px'}}>
              {list.map((item, index) => (
                <div key={index} className='col-6'>
                  <Link to={item.link} className='d-flex flex-row align-items-center text-black'>
                    <div style={{height: '95px', width: '95px'}}>
                      <Img image={item.image.gatsbyImageData} file={item.image.file}/>
                    </div>
                    <div className='col ms-3'>
                      <p className='fw-semibold'>{item.title}</p>
                      <p className='mb-0'>{item.description}</p>
                    </div>
                  </Link>
                </div>
              ))}
            </Row>
          }
        </div>
      </Container>
    </Section>
  );
};

export default LinkList
